/**HOUSE OF CARDS APP: LANDING PAGE**/

export default function LandingPage() {
  return (
    <div className="landing-window">
      <div className="landing-intro-container bg-primary text-white text-center">
        <h1 className="landing-heading mb-3">Welcome to THE HOUSE OF CARDS!</h1>
        <h3 className="landing-sub-heading">
          Play our Mystery Mania Card Game and Win Amazing Prizes!
        </h3>
      </div>
    </div>
  );
}
